import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { SchoolActivityAttendee } from '../../../services/school-activity.service';
import {
	BulkRemoveAttendeeAndSignUpAction,
	BulkSignOutForActivitySuccessAction,
	BulkSignUpForActivitySuccessAction,
	GetAttendeesForInstanceAction,
	RemoveAttendeeAndSignUpActionSuccess,
	SignUpForActivitySuccessAction,
} from '../actions/school-activity-attendees.actions';

export const schoolActivityAttendeesInitialState: EntityState<SchoolActivityAttendee> = {
	ids: [],
	entities: {},
};

export const schoolActivityAttendeesAdapter: EntityAdapter<SchoolActivityAttendee> = createEntityAdapter<SchoolActivityAttendee>();

export const schoolActivityAttendeesReducer = createReducer(
	schoolActivityAttendeesInitialState,
	on(GetAttendeesForInstanceAction, (state, { attendees }) => schoolActivityAttendeesAdapter.upsertMany(attendees, state)),
	on(SignUpForActivitySuccessAction, (state, { attendee }) => schoolActivityAttendeesAdapter.upsertOne(attendee, state)),
	on(BulkSignUpForActivitySuccessAction, (state, { attendees }) => schoolActivityAttendeesAdapter.upsertMany(attendees, state)),
	on(BulkSignOutForActivitySuccessAction, (state, { attendeeIds }) => schoolActivityAttendeesAdapter.removeMany(attendeeIds, state)),
	on(RemoveAttendeeAndSignUpActionSuccess, (state, { attendeeId }) => schoolActivityAttendeesAdapter.removeOne(attendeeId, state)),
	on(BulkRemoveAttendeeAndSignUpAction, (state, { attendeeIds }) => schoolActivityAttendeesAdapter.removeMany(attendeeIds, state))
);
